import { supabase } from '../lib/supabase';

export async function extractRecipe(url: string) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('Not authenticated');

  // Use Supabase Functions in production, local API in development
  const baseUrl = import.meta.env.DEV 
    ? '/api'
    : `${import.meta.env.VITE_SUPABASE_URL}/functions/v1`;

  const response = await fetch(`${baseUrl}/extract-recipe`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${session.access_token}`
    },
    body: JSON.stringify({ url })
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to extract recipe');
  }

  return response.json();
}

export async function enhanceRecipe(recipe: any) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('Not authenticated');

  // Use Supabase Functions in production, local API in development
  const baseUrl = import.meta.env.DEV 
    ? '/api'
    : `${import.meta.env.VITE_SUPABASE_URL}/functions/v1`;

  const response = await fetch(`${baseUrl}/enhance-recipe`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${session.access_token}`
    },
    body: JSON.stringify({ recipe })
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to enhance recipe');
  }

  return response.json();
}